import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import { connect } from 'react-redux';
import humanize from 'underscore.string/humanize';
import { getParent } from '../../../redux/actions/petActions';

const defaultAvatar = `${process.env.PUBLIC_URL}/img/default-animal-black.png`;

class SelectPet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parentId: null,
      petList: [],
      autoOpenedForParentId: null,
    };
  }

  componentDidMount() {
    const { selectedParent, pets } = this.props;
    this.getPetsData({ selectedParent, pets });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.getPetsData({
      selectedParent: nextProps.selectedParent,
      pets: nextProps.pets,
    });
  }

  getPetsData = ({ selectedParent, pets }) => {
    if (!selectedParent) {
      this.setState({
        parentId: null,
        petList: [],
        autoOpenedForParentId: null,
      });
      return;
    }

    const nextParentId = selectedParent._id;
    const reduxPets = Array.isArray(pets?.petList) ? pets.petList : null;
    const embeddedPets = Array.isArray(selectedParent.pets)
      ? selectedParent.pets
      : null;

    // Parent changed: fetch pets for this parent. Do not apply a previous
    // parent's redux petList (stale) while the request is in flight.
    if (nextParentId !== this.state.parentId) {
      const initialPets =
        embeddedPets && embeddedPets.length > 0 ? embeddedPets : [];
      this.setState(
        {
          parentId: nextParentId,
          petList: initialPets,
          autoOpenedForParentId: null,
        },
        () => {
          this.props.getParent(nextParentId);
          if (initialPets.length) {
            this.autoSelectPet(initialPets);
          }
        },
      );
      return;
    }

    // Same parent: prefer fetched redux pets when present.
    if (reduxPets) {
      this.setState({ petList: reduxPets }, () => {
        this.autoSelectPet(reduxPets);
      });
      return;
    }

    // Fallback: non-empty pets embedded on the parent object.
    if (embeddedPets && embeddedPets.length > 0) {
      this.setState({ petList: embeddedPets }, () => {
        this.autoSelectPet(embeddedPets);
      });
    }
  };

  // One-pet auto-open — copy reference only; never mutate the pets array.
  autoSelectPet(petList) {
    if (!Array.isArray(petList) || petList.length !== 1) {
      return;
    }
    if (this.props.viewMode || !this.props.selectPet) {
      return;
    }
    if (this.state.autoOpenedForParentId === this.state.parentId) {
      return;
    }
    this.setState({ autoOpenedForParentId: this.state.parentId });
    this.props.selectPet(petList[0]);
  }

  render() {
    const {
      title = 'Select Pet',
      showNewPetButton = false,
      collapse,
      selectedPet,
      selectPet,
      viewMode,
      selectedParent,
    } = this.props;

    const { petList } = this.state;
    // Show the Select Pet panel as soon as a parent is selected (incl. loading).
    const panelOpen = Boolean(
      collapse && (selectedParent || showNewPetButton),
    );
    // Keep heading active once a parent is selected (including while pets load).
    const headingDisabled =
      !selectedParent || (!collapse && showNewPetButton);

    const petCards = petList.map((pet) => {
      return viewMode ? (
        selectedPet === pet._id ? (
          <div className="pet-card" key={pet._id}>
            <div className="pet-card-body">
              <img
                className="pet-image"
                src={pet.image ? pet.image : defaultAvatar}
                alt="avatar"
              />
              <div className="pet-card-info">
                <p className="pet-name">{pet.name}</p>
                <p className="pet-details pet-species">
                  {pet.species || 'N/A'}
                </p>
                <p className="pet-details pet-breed">
                  {pet.breed || 'N/A'}
                </p>
                <p className="pet-details pet-gender">
                  {humanize(pet.gender) || 'N/A'}
                </p>
              </div>
            </div>
          </div>
        ) : null
      ) : (
        <div
          className={
            'pet-card ' +
            (selectPet && !viewMode ? 'not-view-mode ' : '') +
            (this.props.selectedPet === pet._id ? 'selected-pet ' : '')
          }
          key={pet._id}
          onClick={() =>
            selectPet && !viewMode ? this.props.selectPet(pet) : false
          }
        >
          {selectPet && !viewMode && (
            <div className="select-wrapper">
              <input
                id={pet._id}
                type="radio"
                checked={this.props.selectedPet === pet._id}
                onChange={() => this.props.selectPet(pet)}
              />
              <label htmlFor={pet._id} className="checkmark" />
            </div>
          )}
          <div className="pet-card-body">
            <img
              className="pet-image"
              src={pet.image ? pet.image : defaultAvatar}
              alt="avatar"
            />
            <div className="pet-card-info">
              <p className="pet-name">
                <span className="pet">{pet.name}</span>
              </p>
              <p className="pet-details pet-species">
                {pet.species || 'N/A'}
              </p>
              <p className="pet-details pet-breed">
                {pet.breed || 'N/A'}
              </p>
              <p className="pet-details pet-gender">
                {humanize(pet.gender) || 'N/A'}
              </p>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="content-holder find-parent-wrapper select-pet-panel">
        <div className="row">
          <div className="col-md-6">
            <h3 className={headingDisabled ? 'loyal-disable-tab-text' : ''}>
              {title}
            </h3>
          </div>
          <div className="col-md-6">
            {showNewPetButton && collapse && (
              <button
                className="btn pull-right add-new-pet-register-btn"
                disabled={!collapse}
                onClick={this.props.showNewPetAction}
              >
                <span className="lnr lnr-plus-circle" />
                Add New Pet
              </button>
            )}
          </div>
        </div>
        <Collapse isOpen={panelOpen}>
          <div className="row">
            <div className="col-md-12">
              {/* Scroll only this region when many pets; header/Cancel stay fixed. */}
              <div className="select-pet-scroll">
                <div className="pet-cards">{petCards}</div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = {
  getParent,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectPet);
